module.exports = __webpack_public_path__ + "img/SplashScience2.5948cb4e.jpg";